module.exports = __webpack_public_path__ + "files/041d66101e96d2bfd2c6a3244a319b3d.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/lora-bolditalic-webfont.woff2
 ** module id = 939
 ** module chunks = 0
 **/